import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="flex items-center gap-1 bg-white/10 rounded-lg p-1">
      <button
        onClick={() => setLanguage('de')}
        className={`px-2 py-1 rounded text-xl transition-all ${
          language === 'de'
            ? 'bg-white/20 scale-110'
            : 'opacity-60 hover:opacity-100 hover:bg-white/10'
        }`}
        title="Deutsch"
      >
        🇩🇪
      </button>
      <button
        onClick={() => setLanguage('en')}
        className={`px-2 py-1 rounded text-xl transition-all ${
          language === 'en'
            ? 'bg-white/20 scale-110'
            : 'opacity-60 hover:opacity-100 hover:bg-white/10'
        }`}
        title="English"
      >
        🇬🇧
      </button>
    </div>
  );
};

export default LanguageSwitcher;
